import { Action, Module, VuexModule } from "vuex-class-modules";

@Module({ generateMutationSetters: true })
export class FlashNewsFilterStore extends VuexModule {
    productTags: Set<string> = new Set();
    serviceTags: Set<string> = new Set();
    operatingRegimeTags: Set<string> = new Set();
    applicationTags: Set<string> = new Set();
    customTags: Set<string> = new Set();
    logicalOperator: "AND" | "OR" = "AND";
    afterYear: number = 0;
    beforeYear: number = 0;

    @Action
    public toggleProduct(name: string): void {
        const newTags = new Set(this.productTags.values());

        if (newTags.has(name)) {
            newTags.delete(name);
        } else {
            newTags.add(name);
        }

        this.productTags = newTags;
    }

    @Action
    public toggleService(name: string): void {
        const newTags = new Set(this.serviceTags.values());

        if (newTags.has(name)) {
            newTags.delete(name);
        } else {
            newTags.add(name);
        }

        this.serviceTags = newTags;
    }

    @Action
    public toggleOperatingRegime(name: string): void {
        const newTags = new Set(this.operatingRegimeTags.values());

        if (newTags.has(name)) {
            newTags.delete(name);
        } else {
            newTags.add(name);
        }

        this.operatingRegimeTags = newTags;
    }

    @Action
    public toggleApplication(name: string): void {
        const newTags = new Set(this.applicationTags.values());

        if (newTags.has(name)) {
            newTags.delete(name);
        } else {
            newTags.add(name);
        }

        this.applicationTags = newTags;
    }

    @Action
    public toggleCustomTags(name: string): void {
        const newTags = new Set(this.customTags.values());

        if (newTags.has(name)) {
            newTags.delete(name);
        } else {
            newTags.add(name);
        }

        this.customTags = newTags;
    }

    @Action
    public resetFilters(): void {
        this.productTags = new Set();
        this.serviceTags = new Set();
        this.applicationTags = new Set();
        this.operatingRegimeTags = new Set();
        this.customTags = new Set();
        this.afterYear = 0;
        this.beforeYear = 0;
    }
}
